import { render, staticRenderFns } from "./assetprofile.vue?vue&type=template&id=720022d6&scoped=true&"
import script from "./assetprofile.js?vue&type=script&lang=js&"
export * from "./assetprofile.js?vue&type=script&lang=js&"
import style0 from "./assetprofile.vue?vue&type=style&index=0&id=720022d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720022d6",
  null
  
)

export default component.exports